import GenericHeader, { GenericHeaderProps } from "components/ui/GenericHeader";
import CarouselPlaceholder, { CountItems } from "components/ui/Carousel/CarouselPlaceholder";
import {
    ComponentParams,
    ComponentRendering,
    useSitecoreContext,
} from "@sitecore-jss/sitecore-jss-nextjs";
import ImageCarouselElement from "./ImageCarouselElement";

export type ImageCarouselProps = {
    rendering: ComponentRendering & { params: ComponentParams };
    params: { [key: string]: string };
    fields: GenericHeaderProps;
};

const ImageCarousel = (props: ImageCarouselProps) => {
    const {
        sitecoreContext: { pageEditing },
    } = useSitecoreContext();

    const phKey = `ImageCarousel-${props.params.DynamicPlaceholderId}`;
    const slides = props.rendering.placeholders
        ? Object.values(props.rendering.placeholders)[0]
        : [];
    const scSlidesLength = CountItems(slides);
    const isSlidesCountOver = slides && scSlidesLength > 3;

    return (
        <GenericHeader
            Id={props.rendering?.uid}
            HeaderHeadline={props.fields?.HeaderHeadline}
            HeaderSubHeadline={props.fields?.HeaderSubHeadline}
            HeaderCTA={props.fields?.HeaderCTA}
            headlineSize={props.params?.HeaderHeadlineSize}
        >
            <CarouselPlaceholder
                phkey={phKey}
                componentsProps={props.rendering}
                carouselProps={{
                    id: "imageCarousel",
                    gap: ["sp16", null, "sp20"],
                    slidesToShow: [1, 2, 2, isSlidesCountOver ? 3.3 : 3],
                    dots: [
                        slides && scSlidesLength > 1,
                        slides && scSlidesLength > 2,
                        null,
                        slides && scSlidesLength > 3.3,
                    ],
                }}
                carouselEditProps={{
                    width: [
                        `calc(100% / 1 * ${scSlidesLength})`,
                        `calc(100% / 2 * ${scSlidesLength})`,
                        `calc(100% / ${isSlidesCountOver ? 3.3 : 3} * ${scSlidesLength})`,
                    ],
                }}
            >
                {!pageEditing &&
                    slides.map((slide: any) => {
                        return <ImageCarouselElement id={slide.uid} key={slide.uid} {...slide} />;
                    })}
            </CarouselPlaceholder>
        </GenericHeader>
    );
};

export default ImageCarousel;
